module.exports = __webpack_public_path__ + "img/banner-mobile.1c664285.jpg";